import { trackRSCheckoutClicked } from '@app/analytics/track';
import type { ShippingMethod } from '@app/types/cart/ShippingMethod';
import { Box, Button, constants } from '@redbubble/design-system';
import { defineMessages, useIntl } from '@redbubble/next/intl';
import {
  RSCheckoutLocation,
  useRudderstackClient,
} from '@redbubble/next-provider/rudderstack';
import React from 'react';
import styles from '../OrderSummary.module.scss';
import { useOrderSummaryContext } from '../orderSummaryContext';

interface CheckoutButtonProps {
  shippingMethod: ShippingMethod;
}

const messages = defineMessages({
  checkoutButton: {
    defaultMessage: 'Checkout',
  },
  checkoutButtonActions: {
    defaultMessage:
      '- selects {shippingMethod} shipping and opens check out page',
  },
});

export const CheckoutButton = ({ shippingMethod }: CheckoutButtonProps) => {
  const { loading: orderSummaryLoading } = useOrderSummaryContext();
  const intl = useIntl();
  const { RudderstackClient } = useRudderstackClient();

  const handleClick = () => {
    trackRSCheckoutClicked({
      rsClient: RudderstackClient,
      checkoutType: 'standard',
      location: RSCheckoutLocation.Cart,
    });
    window.location.assign('/check-out');
  };

  return (
    <Box className={styles.checkoutButton}>
      <Button
        intent={constants.PRIMARY}
        loading={orderSummaryLoading}
        size={constants.LARGE}
        strong
        fluid
        onClick={() => handleClick()}
        role="link"
      >
        {intl.formatMessage(messages.checkoutButton)}
        <span className="clipped">
          {` ${intl.formatMessage(messages.checkoutButtonActions, {
            shippingMethod,
          })}`}
        </span>
      </Button>
    </Box>
  );
};
